/**
 * Singleton by invariant: at most one full-screen store loader exists per
 * document, so these ids carry no identity suffix.
 */
export const STORE_LOADING_COVER_TEST_IDS = {
    root: 'store-loading-cover',
    /**
     * Legacy id the Playwright suites wait on for the store-level overlay
     * (domain-checkout `waitForStoreLoaderHidden`, domain-store success
     * screen). Remove once those suites target the root id.
     */
    legacySpinner: 'storeCircularLoader',
    label: 'store-loading-cover-label',
} as const;

export const STORE_LOADING_COVER_SELECTOR = `[data-testid="${STORE_LOADING_COVER_TEST_IDS.root}"]`;

/** Set on `<html>` while client code wants the loader on screen. */
export const STORE_LOADER_VISIBLE_ATTRIBUTE = 'data-store-loader-visible';

/** Set on `<html>` once the shop finished booting and released the cover. */
export const STORE_LOADER_DISMISSED_ATTRIBUTE = 'data-store-loader-dismissed';

/** Set on `<body>` for shop routes, which start under the cover. */
export const STORE_LOADER_COVERED_ATTRIBUTE = 'data-store-loader-covered';

/**
 * `dataset` key (not an attribute name — reads as `data-store-loader-dismissing`
 * in the DOM) set on the cover once a dismissal is in flight, so the second
 * caller (`useLoaderState` and the shop mount both request one) does not start
 * the waits again.
 */
export const STORE_LOADER_DISMISSING_DATASET_KEY = 'storeLoaderDismissing';

/** Set on `<html>` while the pre-auth loader uses storefront background art. */
export const LOGIN_LOADER_BG_MODE_ATTRIBUTE = 'data-login-loader-bg-mode';

export const STORE_LOADING_COVER_BG_MOBILE_VAR = '--store-loading-cover-bg-mobile';

export const STORE_LOADING_COVER_BG_DESKTOP_VAR = '--store-loading-cover-bg-desktop';

/** Keep in sync with globals.css `.app-store-background` desktop image swap. */
export const STORE_BACKGROUND_DESKTOP_MEDIA_QUERY =
    '(min-width: 1024px), (orientation: landscape)';

export const STORE_LOADING_COVER_BACKGROUND = 'rgba(0, 0, 0, 0.9)';

export const STORE_LOADING_COVER_FOREGROUND = '#fff';

export const STORE_LOADING_COVER_GAP = 16;

export const STORE_LOADING_COVER_SPINNER_SIZE = 48;

export const STORE_LOADING_COVER_SPINNER_CLASS = 'store-loading-cover-spinner';

/**
 * Box for a publisher's processing animation (Lottie or WebM). Fixed and
 * inline like the spinner so the server markup and hydration agree; uploads
 * are capped at 512px and scale down into it.
 */
export const STORE_LOADING_COVER_ANIMATION_SIZE = 96;

export const STORE_LOADING_COVER_LABEL_KEY = 'processing';

/** Above the shared-ui checkout iframe wrapper (1500) so one layer covers the SDK. */
export const STORE_LOADING_COVER_Z_INDEX = 2100;
